import { makeStyles } from '@material-ui/core'
import { useFormContext } from 'react-hook-form'

import helpers from 'helpers'

const styles = (isFixed, isFull, isCompact) =>
  makeStyles(() => {
    const { watch } = useFormContext()
    const { fontFamily, primaryColor } =
      helpers.cookies.banner.getStyleTokens(watch)

    return {
      title: {
        fontSize: isCompact ? 16 : isFull ? 22 : isFixed ? 20 : 24,
        lineHeight: isFull ? 1.35 : 1.5,
        fontWeight: 600,
        fontFamily: fontFamily,
        color: primaryColor,
      },
    }
  })

export default styles
